import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { FeaturedPieces } from "../components/FeaturedPieces";
import { Manifesto } from "../components/Manifesto";
import { Reveal } from "../components/Reveal";

const Cta = () => (
  <section className="py-28 md:py-40" data-testid="cta-section">
    <div className="mx-auto max-w-4xl px-6 text-center md:px-10">
      <Reveal>
        <p className="mb-6 text-xs uppercase tracking-[0.35em] text-golddark">The collection awaits</p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-serif text-5xl leading-[1.05] tracking-tighter text-ink md:text-7xl">
          Adorn the <em className="italic text-golddark">everyday.</em>
        </h2>
      </Reveal>
      <Reveal delay={0.25}>
        <Link
          to="/catalogue"
          data-testid="cta-catalogue-btn"
          className="mt-12 inline-flex items-center gap-3 rounded-full bg-ink px-10 py-5 text-xs uppercase tracking-[0.25em] text-ivory transition-colors duration-500 hover:bg-golddark"
        >
          Browse the Catalogue <ArrowRight size={14} strokeWidth={1.5} />
        </Link>
      </Reveal>
    </div>
  </section>
);

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <FeaturedPieces />
      <Manifesto />
      <Cta />
    </main>
  );
}
